import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ResponsiveHeader from '../Header';
import {StyledMenuDiv} from '../Styled/index';
import history from '../../Utility/history';
import { Redirect } from 'react-router-dom';
import { privateRoutesPath, publicRoutesPath } from '../../Routes';
import { styled, useTheme } from '@mui/material/styles';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleValidateCodevalue } from '../../Utility/constant';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import '../../Assets/css/sidebar.css';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import dashboard_select from '../../Assets/images/dashboard_select.png';
import dashboard from '../../Assets/images/dashboard.png';

import customer_select from '../../Assets/images/customer_select.png';
import customer from '../../Assets/images/customer_new.png';
import product_select from '../../Assets/images/product_select.png';
import product from '../../Assets/images/product_new.png';

import lead_select from '../../Assets/images/lead_select.png';
import lead from '../../Assets/images/lead_new.png';

import template_select from '../../Assets/images/template_select.png';
import template from '../../Assets/images/template_new.png';

import setting_select from '../../Assets/images/settings_select.png';
import setting from '../../Assets/images/settings_new.png';

import audit_select from '../../Assets/images/audit_select.png';
import audit from '../../Assets/images/audit_new.png';

import order_select from '../../Assets/images/order_select.png';
import order from '../../Assets/images/order_new.png';
import invoice_select from '../../Assets/images/invoice_select.png';
import invoice from '../../Assets/images/invoice_new.png';
import Avatar from '@mui/material/Avatar';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { Tooltip } from '@mui/material';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { CallProvider } from '../TeleCalling/CallContext';
import GlobalCallOverlay from '../TeleCalling/GlobalCallOverlay';
import I18nInspectorOverlay from '../I18nInspector/I18nInspectorOverlay';
import { resetAllPreserveSearch } from '../../Store/SearchReducer/action';

const drawerWidth = 220;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // width: '90%',
    width: `calc(100vw - ${drawerWidth}px)`,
    padding: "24px 12px",
    height: "100vh",
    paddingRight: "15px",
    ...(open && {
      // marginLeft: "65px",
    }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));


export default function PrivateLayout(props) {

    const [selectedMenu , setSelectedMenu] = React.useState('Dashboard');
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const currentUser = useSelector(state => state?.owner?.currentuser);

    const [headerConfig, setHeaderConfig] = React.useState({
      variant: "permanent",
      marginLeft:""
    })
     const isMobile = useIsMobile();
    const [isI18nOpen, setIsI18nOpen] = React.useState(false);
    
    const handleDrawerOpen = () => {
        setOpen(!open);
    };

    const handleCloseOpenMiniDrawer = () => {

      setHeaderConfig((prev) => ({
          ...prev,
          variant: prev?.variant == "" ? "permanent": "",
        }))
          setOpen(true);
    }

    
    const handleDrawerClose = () => {
        setOpen(false);
    };


    useEffect(() => {

      // handleRenderSpecificRoutes();

    },[specificRolePermission])

    if (currentUser?.resetPassword === true) {
        return <Redirect to={publicRoutesPath.FIRST_USER_PASSWORD_SETUP} />;
    }


    const handleSelectedMenu = (menu) => {
        setSelectedMenu(menu);
        dispatch(resetAllPreserveSearch());
        switch(menu) {
            case 'Dashboard': 
                history.push(privateRoutesPath.DASHBOARD);
                break;
            case 'Leads': 
                history.push(privateRoutesPath.LEADS);
                break;
            case 'Customers': 
                history.push(privateRoutesPath.CUSTOMER);
                break;
            case 'Tasks': 
                history.push(privateRoutesPath.TASKS);
                break;
            case 'TeleCalling':
                history.push(privateRoutesPath.TELECALLING);
                break;
                
            case 'Merchants': 
                history.push(privateRoutesPath.MERCHANT);
                break;
            case 'Products': 
                history.push(privateRoutesPath.PRODUCT);
                break;
            case 'Invoice': 
                history.push(privateRoutesPath.INVOICE);
                break;
            case 'Order': 
              history.push(privateRoutesPath.ORDER);
              break;
            case 'Campaign':
              history.push(privateRoutesPath.BIZTANTU_CAMPAIGN);
              break;
            case 'Template':
              history.push(privateRoutesPath.BIZTANTU_TEMPLATE);
              break;
            case 'Audit':
              history.push(privateRoutesPath.BIZTANTU_AUDIT)
              break;
            case 'Configurations': 
                history.push(privateRoutesPath.CONFIGURATION);
                break;
            case 'Reports': 
                history.push(privateRoutesPath.REPORTS);
                break;
            case 'Profile': 
                history.push(privateRoutesPath.PROFILE);
                break;
            case 'Workflow' :
              history.push(privateRoutesPath.WORKFLOW);
        }
        handleDrawerClose()
        
    }

  return (
    <CallProvider>
    <Box sx={{ display: 'flex'}}>
      <CssBaseline />
      <ResponsiveHeader 
        handleCloseOpenMiniDrawer = {handleCloseOpenMiniDrawer} 
        open={open} 
        drawerWidth={drawerWidth} 
        handleDrawerOpen={handleDrawerOpen} 
        handleDrawerClose={handleDrawerClose}
        onOpenI18n={() => setIsI18nOpen(true)}
      />
      <Drawer
      className = {open ? "loader-excluded" : ""}
        sx={{
          width: drawerWidth,
          // width: "57px !important",
          flexShrink: 0,
          whiteSpace: 'nowrap',
          boxSizing: 'border-box',
          ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': {
              ...openedMixin(theme),
              overflowY : 'auto',
              top: "85px",
              // left: "15px",
              borderRadius: "10px",
             height: "calc(100vh - 88px) !important",
              padding: "4px !important",
        
          
            },
          }),
          ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': {
              ...closedMixin(theme),
              overflowY : "auto",
              top: "85px",
              // left: "15px",
              borderRadius: "10px",
              height: "calc(100vh - 88px) !important",
              padding: "4px !important",
        
          
            },
          }),
    
        }}
        variant={isMobile ? "temporary" : !open ? headerConfig?.variant : ""}
        // variant={!open ? headerConfig?.variant : ""}
        anchor="left"
        open={open}
      >
        <Toolbar>
           {open &&  <ListItemText  className='navMenuTitle' sx={{color: "black !important", fontWeight: 'bold', opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"LEFT_NAV_MENU_TOGGLE")} />
                }
        </Toolbar>
              <IconButton 
                className={`drawer-toggle ${open ? "close-open" : "open-close"}`}
                color="inherit"
                aria-label={open ? "close drawer" : "open drawer"}
                onClick={handleDrawerOpen}
                edge="start"
              >
                <ArrowForwardIosOutlinedIcon/>
              </IconButton>
          <Divider sx={{ borderColor: "#656565"}} />
        <Box sx={{  height: '100vh'}}>
          <List>
              <StyledMenuDiv>
              {(specificRolePermission?.isDashboradView ) &&
                <Tooltip
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"DASHBOARD_SIDEBAR_MENU")}>
              <ListItem key="Dashboard" sx={{ display: 'block' }} disablePadding onClick={() => handleSelectedMenu('Dashboard')}>
                <ListItemButton
                  sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'initial',
                  px: 2.5,
                }}
                // selected = {selectedMenu == 'Dashboard' }
                selected = {props.location.pathname.split("/").includes('dashboard')}
                >
                    <ListItemIcon
                     sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'initial',
                      }}
                    // sx={{minWidth: 0}}
                    >
                    {props.location.pathname.split("/").includes('dashboard')  ? <img src={dashboard_select} /> : <img src={dashboard} /> }
                    </ListItemIcon>
                  <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"DASHBOARD_SIDEBAR_MENU")} />
                </ListItemButton>
              </ListItem>
              </Tooltip>
              }

              {(specificRolePermission?.isReportView && !isMobile) && 
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"REPORTS_SIDEBAR_MENU")}>
              <ListItem key='Reports' disablePadding onClick={() => handleSelectedMenu('Reports')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Campaign' }
                     selected = {props.location.pathname.split("/").includes('reports')}
                     >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                        {props.location.pathname.split("/").includes('reports') ? <SummarizeIcon style={{color: "white"}} /> : <SummarizeIcon />  }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"REPORTS_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>
                }


                {(specificRolePermission?.isCustomerView && !isMobile) &&
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"CUSTOMER_SIDEBAR_MENU")}>
                <ListItem key='Customers' disablePadding onClick={() => handleSelectedMenu('Customers')}>
                <ListItemButton  
                selected = {props.location.pathname.split("/").includes('customer')}
                    // selected = {selectedMenu == 'Customers' } 
                    sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    >
                    <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                    {props.location.pathname.split("/").includes('customer') ? <img src={customer_select} /> : <img src={customer} />  }
                    
                      </ListItemIcon>
                  <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"CUSTOMER_SIDEBAR_MENU")} />
                </ListItemButton>
              </ListItem>
              </Tooltip>
              }


              {(specificRolePermission?.isLeadView) &&
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"LEAD_SIDEBAR_MENU")}>
              <ListItem key='Leads' disablePadding onClick={() => handleSelectedMenu('Leads')}>
                <ListItemButton
                    sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    // selected = {selectedMenu == 'Leads' }
                    selected = {props.location.pathname.split("/").includes('leads')}
                    >
                    <ListItemIcon
                      sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}
                    >
                    {props.location.pathname.split("/").includes('leads') ? <img src={lead_select} /> : <img src={lead} />  }
                    </ListItemIcon>
                  <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"LEAD_SIDEBAR_MENU")} />
                </ListItemButton>
              </ListItem>
              </Tooltip>
              }

              {(specificRolePermission?.isTaskView) &&
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"TASKS_SIDEBAR_MENU")}>
              <ListItem key='Tasks' disablePadding onClick={() => handleSelectedMenu('Tasks')}>
                <ListItemButton  
                selected = {props.location.pathname.split("/").includes('tasks')}
                    sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    >
                    <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                    {props.location.pathname.split("/").includes('tasks') ? <AssignmentIcon style={{color: "white"}}/> : <AssignmentIcon />  }
                    
                      </ListItemIcon>
                  <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"TASKS_SIDEBAR_MENU")} />
                </ListItemButton>
              </ListItem>
              </Tooltip>
              }
            
              {/* {(specificRolePermission?.isVendorView) &&<ListItem key='Merchants' disablePadding onClick={() => handleSelectedMenu('Merchants')}>
                <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Merchants' }
                     selected = {props.location.pathname.split("/").includes('merchant')}
                    >
                    <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                    {props.location.pathname.split("/").includes('merchant') ? <img src={vendor_select} /> : <img src={vendor} />  }
                    
                      </ListItemIcon>
                  <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"VENDOR_SIDEBAR_MENU")} />
                </ListItemButton>
              </ListItem>} */}

             {(specificRolePermission?.isProductView && !isMobile) && 
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"PRODUCT_SIDEBAR_MENU")}>
             <ListItem key='Products' disablePadding onClick={() => handleSelectedMenu('Products')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                        // selected = {selectedMenu == 'Products' }
                        selected = {props.location.pathname.split("/").includes('product') || props.location.pathname.split("/").includes('merchant')}
                        >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                        {(props.location.pathname.split("/").includes('product') || props.location.pathname.split("/").includes('merchant')) ? <img src={product_select} /> : <img src={product} />  }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"PRODUCT_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>
                }
                
                {(specificRolePermission?.isOrderView && !isMobile) &&
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"SALES_ORDER_SIDEBAR_MENU")}>
                <ListItem key='Order' disablePadding onClick={() => handleSelectedMenu('Order')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Order' }
                      // selected = {selectedMenu == 'Order' }
                      selected = {props.location.pathname.split("/").includes('order')}
                     >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                        {props.location.pathname.split("/").includes('order') ? <img src={order_select} /> : <img src={order} /> }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"SALES_ORDER_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>
                }

                {(specificRolePermission?.isInvoiceView && !isMobile) && 
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"INVOICE_SIDEBAR_MENU")}>
                <ListItem key='Invoice' disablePadding onClick={() => handleSelectedMenu('Invoice')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Invoice' }
                     selected = {props.location.pathname.split("/").includes('invoice')}
                     >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                        {props.location.pathname.split("/").includes('invoice') ? <img src={invoice_select} /> : <img src={invoice} />  }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"INVOICE_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>
                }
               
    {/* {(specificRolePermission?.isTaskView) &&<ListItem key='TeleCalling' disablePadding onClick={() => handleSelectedMenu('TeleCalling')}>
                <ListItemButton
                selected = {props.location.pathname.split("/").includes('telecalling')}
                    sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    >
                    <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                    {props.location.pathname.split("/").includes('telecalling') ? <AssignmentIcon style={{color: "white"}}/> : <AssignmentIcon />  }

                      </ListItemIcon>
                  <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary="TeleCalling" />
                </ListItemButton>
              </ListItem>} */}
                {(specificRolePermission?.isNotificationView && !isMobile) && 
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"TEMPLATE_SIDEBAR_MENU")}>
                  <ListItem key='Template' disablePadding onClick={() => handleSelectedMenu('Template')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Template' }
                     selected = {props.location.pathname.split("/").includes('template') || props.location.pathname.split("/").includes('campaign')}
                     >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                        {(props.location.pathname.split("/").includes('template') || props.location.pathname.split("/").includes('campaign')) ? <img src={template_select} /> : <img src={template} />  }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"TEMPLATE_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>}
                {(specificRolePermission?.isWorkflowView && !isMobile) &&
                  <Tooltip 
                  placement="right"
                  title = {open ? "" : handleValidateCodevalue(internationalise,"WORKFLOW_SIDEBAR_MENU")}>
                  <ListItem key='Workflow' disablePadding onClick={() => handleSelectedMenu('Workflow')}>
                      <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                      //  selected = {selectedMenu == 'Campaign' }
                      selected = {props.location.pathname.split("/").includes('workflow')}
                      >
                          <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                          {props.location.pathname.split("/").includes('workflow') ? <AccountTreeIcon style={{color: "white"}} /> : <AccountTreeIcon/>  }
                          </ListItemIcon>
                      <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"WORKFLOW_SIDEBAR_MENU")} />
                      </ListItemButton>
                  </ListItem>
                  </Tooltip>
                }

                {(specificRolePermission?.isAuditView && !isMobile) &&
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"AUDIT_SIDEBAR_MENU")}>
                <ListItem key='Audit' disablePadding onClick={() => handleSelectedMenu('Audit')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Campaign' }
                     selected = {props.location.pathname.split("/").includes('audit')}
                     >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                        {props.location.pathname.split("/").includes('audit') ? <img src={audit_select} /> : <img src={audit} />  }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"AUDIT_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>
                }
                
              </StyledMenuDiv>
              <StyledMenuDiv>

                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"PROFILE_SIDEBAR_MENU")}>
                <ListItem key='Profile' disablePadding onClick={() => handleSelectedMenu('Profile')}>
                 <ListItemButton sx={{minHeight: 48, marginBottom: "0px", justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Configurations' }
                     selected = {props.location.pathname.split("/").includes('profile')}
                     
                     >
                        <ListItemIcon sx={{minWidth: 0, position: 'relative', right: '7px', mr: open ? 1 : 'auto',justifyContent: 'initial', }}>
                          <Avatar style={{ backgroundColor: 'var(--secondary-color)', fontSize: "15px", color: "black", fontWeight: "bold"}}>
                      {currentUser ? `${currentUser?.firstname?.[0]} ${currentUser?.lastname?.[0]}` : "L A"}
                    </Avatar>
                    </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"PROFILE_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>
              
                {(specificRolePermission?.isConfigurationView && !isMobile) &&
                <Tooltip 
                placement="right"
                title = {open ? "" : handleValidateCodevalue(internationalise,"CONFIGURATION_SIDEBAR_MENU")}>
                <ListItem key='Configurations' disablePadding onClick={() => handleSelectedMenu('Configurations')}>
                    <ListItemButton sx={{minHeight: 48, justifyContent: open ? 'initial' : 'initial', px: 2.5,}}
                    //  selected = {selectedMenu == 'Configurations' }
                     selected = {props.location.pathname.split("/").includes('configuration')}
                     
                     >
                        <ListItemIcon sx={{minWidth: 0, mr: open ? 3 : 'auto',justifyContent: 'initial', }}>
                          {props.location.pathname.split("/").includes('configuration') ? <img src={setting_select} /> : <img src={setting} />  }
                        </ListItemIcon>
                    <ListItemText className='sidebarText' sx={{opacity: open ? 1 : 0 }} primary={handleValidateCodevalue(internationalise,"CONFIGURATION_SIDEBAR_MENU")} />
                    </ListItemButton>
                </ListItem>
                </Tooltip>
                }
              </StyledMenuDiv>
           </List>
          <Divider />
        </Box>
      </Drawer>
      <Main open={open}>
        {/* <Box open={open} component="main" sx={{  flexGrow: 1, p: 3 }}> */}
          <Toolbar />
          {props.children}
        {/* </Box> */}
      </Main>
      <GlobalCallOverlay />
      <I18nInspectorOverlay open={isI18nOpen} onClose={() => setIsI18nOpen(false)} />
    </Box>
    </CallProvider>
  );
}